import { render, staticRenderFns } from "./BusinessCoefficientList.vue?vue&type=template&id=47282d6a&scoped=true&"
import script from "./BusinessCoefficientList.vue?vue&type=script&lang=js&"
export * from "./BusinessCoefficientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47282d6a",
  null
  
)

export default component.exports